/*eslint-disable*/
import React, {useEffect, useState} from "react";

import '../../assets/styles/App.css';
import "@fontsource/montserrat";

export default function FunderEditPopUp({isOpen, onClose, onSave, objectData}) {
    const [editErrorMessage, setEditErrorMessage] = useState('');
    const [funderEdited, setFunderEdited] = useState({
        funder_name: "",
        display_name: "",
        masked_name: "",
        funder_partner: "",
        masked_funder_name: "",
        masked_funder: "",
        masked_partner: "",
        country: "",
        country_code: "",
        currency: "",
        currency_code: "",
        yield_target: "",
        cor_target: "",
        id: "",
        updated_at: ""
    });

    useEffect(() => {
        if (objectData) {
            setFunderEdited({
                funder_name: objectData.funder_name,
                display_name: objectData.display_name,
                masked_name: objectData.masked_name,
                funder_partner: objectData.funder_partner,
                masked_funder_name: objectData.masked_funder_name,
                masked_funder: objectData.masked_funder,
                masked_partner: objectData.masked_partner,
                country: objectData.country,
                country_code: objectData.country_code,
                currency: objectData.currency,
                currency_code: objectData.currency_code,
                yield_target: objectData.yield_target,
                cor_target: objectData.cor_target,
                id: objectData.id,
                updated_at: objectData.updated_at
            });
        }
    }, [objectData]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFunderEdited((prevFunder) => ({
            ...prevFunder,
            [name]: value
        }));
    };

    const onSubmit = (event) => {
        event.preventDefault();

        const partner_arr = objectData.display_name.split("-");
        const new_partner = partner_arr[0].trimEnd();

        const upd_masked_name = funderEdited.masked_partner + " - " + funderEdited.masked_funder;
        const upd_masked_funder_name = new_partner + " - " + funderEdited.masked_funder;


        setFunderEdited({...funderEdited, funder_name: funderEdited.funder_name});
        setFunderEdited({...funderEdited, display_name: funderEdited.display_name});
        setFunderEdited({...funderEdited, masked_name: upd_masked_name});
        setFunderEdited({...funderEdited, masked_funder_name: upd_masked_funder_name});
        setFunderEdited({...funderEdited, masked_funder: funderEdited.masked_funder});
        setFunderEdited({...funderEdited, masked_partner: funderEdited.masked_partner});
        setFunderEdited({...funderEdited, country: funderEdited.country});
        setFunderEdited({...funderEdited, country_code: funderEdited.country_code});
        setFunderEdited({...funderEdited, currency: funderEdited.currency});
        setFunderEdited({...funderEdited, currency_code: funderEdited.currency_code});
        setFunderEdited({...funderEdited, yield_target: funderEdited.yield_target});
        setFunderEdited({...funderEdited, cor_target: funderEdited.cor_target});
        setFunderEdited({...funderEdited, id: funderEdited.id});
        setFunderEdited({...funderEdited, updated_at: funderEdited.updated_at});

        onSave(funderEdited);

    };

    return (
        <>
                <div className="bg-dark-transparent fixed w-full flex h-screen bottom-0 z-100 px-4">
                    <div className="w-full h-full flex items-center">
                        <div className="mx-auto bg-white rounded-lg max-w-600-px py-10">
                            <div className="mb-6 rounded-t-lg">
                                <h2 className="text-24-150-no-change text-blue-v-dark text-center">Edit Funder</h2>
                            </div>

                            <form onSubmit={onSubmit}>
                                <div className="px-8">
                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Funder
                                                Name</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                defaultValue={objectData.funder_name}
                                                readOnly>
                                            </input>
                                        </div>

                                    </div>

                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Display
                                                Name</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                defaultValue={objectData.display_name}
                                                readOnly>
                                            </input>
                                        </div>

                                    </div>

                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark"
                                                   htmlFor="email">Partner</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                defaultValue={objectData.funder_partner}
                                                readOnly>
                                            </input>
                                        </div>

                                    </div>

                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Masked
                                                Funder Name</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                name="masked_funder"
                                                value={funderEdited.masked_funder}
                                                placeholder={objectData.masked_funder}
                                                onChange={handleChange}>
                                            </input>
                                        </div>

                                    </div>


                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Masked
                                                Partner Name</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                name="masked_partner"
                                                value={funderEdited.masked_partner}
                                                placeholder={objectData.masked_partner}
                                                onChange={handleChange}>
                                            </input>
                                        </div>

                                    </div>


                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Yield
                                                Target</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                name="yield_target"
                                                value={funderEdited.yield_target}
                                                placeholder={objectData.yield_target}
                                                onChange={handleChange}>
                                            </input>
                                        </div>

                                    </div>


                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">COR
                                                Target</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                name="cor_target"
                                                value={funderEdited.cor_target}
                                                placeholder={objectData.cor_target}
                                                onChange={handleChange}>
                                            </input>
                                        </div>

                                    </div>


                                    <div className="flex justify-center mt-8">
                                        <button
                                            className="bg-yellow text-16-19 text-blue-v-dark py-2 px-12 rounded"
                                            type="submit"
                                        >
                                            <i className="fa fa-thumbs-up" aria-hidden="true"></i>

                                            &nbsp; Save &nbsp;
                                        </button>
                                        {<button
                                            className="text-16-19 px-12 py-2 ml-3 items-center text-blue rounded"
                                            type="button"
                                            onClick={onClose}
                                        >
                                            <i className="fa fa-times" aria-hidden="true"></i>

                                            &nbsp;&nbsp; Close &nbsp;&nbsp;
                                        </button>}
                                    </div>
                                </div>
                            </form>

                            {editErrorMessage && (
                                <div className="form-error"> {editErrorMessage} </div>
                            )}


                        </div>
                    </div>
                </div>

        </>
    );
}